import { z } from 'zod';
import { POSITION_STATUSES } from '../constants';
import { objectIdSchema, paginationQuerySchema, santimSchema } from './common';
import { outcomeKeySchema } from './markets';

export const quoteSchema = z.object({
  marketId: objectIdSchema,
  outcomeKey: outcomeKeySchema,
  stake: santimSchema,
});
export type QuoteBody = z.infer<typeof quoteSchema>;

export const placeBetSchema = quoteSchema.extend({
  /** UUID generated by the client each time the prediction drawer opens. */
  idempotencyKey: z.string().uuid(),
});
export type PlaceBetBody = z.infer<typeof placeBetSchema>;

export const listBetsQuerySchema = paginationQuerySchema.extend({
  /** `settled` = every status except active (won, lost and refunded). */
  status: z.enum([...POSITION_STATUSES, 'settled']).optional(),
});
export type ListBetsQuery = z.infer<typeof listBetsQuerySchema>;
